import styled from 'styled-components';
import { ModalContent } from '../ui/Modal';
import { above } from '../../styles/libs';

export const StyledModalContent = styled(ModalContent)`
  width: 90%;
  padding: 2rem 1.5rem;

  ${({ theme }) => above(theme.TABLET)`
    padding: 3rem 2.5rem;
  `}

  & img {
    width: 100%;
    margin: 1rem auto;
  }
`;

export default {};
